import React, { useCallback, useEffect, useState } from 'react'
import { css } from '@emotion/core'
import { Body1 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import RootsTechOverlay from '../components/RootsTechOverlay'
import PillButton from '../components/PillButton'

const rowCss = css`
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
  & > * {
    margin-left: 8px;
  }
`
export const domainWhitelist = [/familysearch[.]org/, /familysearch[.]brightspotcdn[.]com/, /rootstech[.]org/]

export const isUrlAllowed = (url) => {
  if (!url) return false

  try {
    const { host } = new URL(url)
    if (!host) return true // honor relative paths (including hashes)
    return window.location.host === host || domainWhitelist.some((domain) => domain.test(host))
  } catch (err) {
    return true // FF blows up on relative paths, which are allowed
  }
}

const Actions = ({ setIsOpen, href }) => {
  const [t] = useTranslation()
  return (
    <div css={rowCss}>
      <PillButton
        onClick={() => {
          setIsOpen(false)
        }}
      >
        {t('common-ui:cancel.action', 'Cancel')}
      </PillButton>
      <PillButton
        type="submit"
        emphasis="high"
        onClick={() => {
          setIsOpen(false)
        }}
        to={href}
        external
        enableLeavingInterceptor={false}
        data-testid="leaving"
        target="_blank"
      >
        {t('common-ui:continue.action', 'Continue')}
      </PillButton>
    </div>
  )
}
export default function LeavingLinkInterceptor({ isOpen, setIsOpen, externalHref }) {
  const [t] = useTranslation()
  const [href, setHref] = useState()
  const [internalIsOpen, internalSetIsOpen] = useState(false)

  const handleClick = useCallback((e) => {
    if (e.target?.tagName.toUpperCase() === 'A' && e.target.href && !e.target.hasAttribute('data-external')) {
      if (!isUrlAllowed(e.target.href)) {
        e.preventDefault()
        setHref(e.target.href)
        internalSetIsOpen(true)
      }
    }
  }, [])

  useEffect(() => {
    if (!setIsOpen) {
      document.addEventListener('click', handleClick)
    }

    return () => document.removeEventListener('click', handleClick)
  }, [handleClick, setIsOpen])

  if (!(isOpen || internalIsOpen)) return null

  return (
    <RootsTechOverlay
      isOpen={isOpen || internalIsOpen}
      setIsOpen={setIsOpen || internalSetIsOpen}
      actions={<Actions href={href || externalHref} setIsOpen={setIsOpen || internalSetIsOpen} />}
    >
      <Body1>
        {t(
          'navigation.leaving-site-message',
          'You are leaving the RootsTech website. Don’t worry. We’ll still be here when you get back.'
        )}
      </Body1>
    </RootsTechOverlay>
  )
}
